// import React from 'react'

// export default function ReceiptIcon({ color = 'white' }: { color?: string }) {
//   return (
//     <svg
//       width='24'
//       height='24'
//       viewBox='0 0 24 24'
//       fill='none'
//       xmlns='http://www.w3.org/2000/svg'
//     >
//       <path
//         d='M20 16.96C20 18.48 19.86 19.56 19.5 20.33C19.5 20.34 19.49 20.36 19.48 20.37C19.26 20.65 18.97 20.79 18.63 20.79C18.1 20.79 17.46 20.44 16.77 19.7C15.95 18.82 14.69 18.89 13.97 19.85L12.96 21.19C12.56 21.73 12.03 22 11.5 22C10.97 22 10.44 21.73 10.04 21.19L9.02002 19.84C8.31002 18.89 7.05999 18.82 6.23999 19.69L6.22998 19.7C5.09998 20.91 4.10002 21.09 3.52002 20.37C3.51002 20.36 3.5 20.34 3.5 20.33C3.14 19.56 3 18.48 3 16.96V7.04C3 5.52 3.14 4.44 3.5 3.67C3.5 3.66 3.50002 3.65 3.52002 3.64C4.09002 2.91 5.09998 3.09 6.22998 4.3L6.23999 4.31C7.05999 5.18 8.31002 5.11 9.02002 4.16L10.04 2.81C10.44 2.27 10.97 2 11.5 2C12.03 2 12.56 2.27 12.96 2.81L13.97 4.15C14.69 5.11 15.95 5.18 16.77 4.3C17.46 3.56 18.1 3.21 18.63 3.21C18.97 3.21 19.26 3.36 19.48 3.64C19.5 3.65 19.5 3.66 19.5 3.67C19.86 4.44 20 5.52 20 7.04V16.96Z'
//         fill={color}
//         stroke={color}
//         strokeWidth='1.5'
//         strokeLinecap='round'
//         strokeLinejoin='round'
//       />
//       <path
//         d='M8 10.25H16'
//         stroke={color === 'white' ? '#4E60FF' : 'white'}
//         strokeWidth='1.5'
//         strokeLinecap='round'
//         strokeLinejoin='round'
//       />
//       <path
//         d='M8 13.75H14'
//         stroke={color === 'white' ? '#4E60FF' : 'white'}
//         strokeWidth='1.5'
//         strokeLinecap='round'
//         strokeLinejoin='round'
//       />
//     </svg>
//   )
// }

import React from 'react'
import type { SVGProps } from 'react'

export default function ReceiptIcon({
  color = 'white',
  ...props
}: SVGProps<SVGSVGElement> & { color?: string }) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={24}
      height={24}
      viewBox='0 0 24 24'
      {...props}
    >
      <path
        fill={color} // Rangni props orqali olamiz
        fillRule='evenodd'
        d='M5.586 4.586C5 5.172 5 6.114 5 8v9c0 1.886 0 2.828.586 3.414S7.114 21 9 21h6c1.886 0 2.828 0 3.414-.586S19 18.886 19 17V8c0-1.886 0-2.828-.586-3.414S16.886 4 15 4H9c-1.886 0-2.828 0-3.414.586M9 8a1 1 0 0 0 0 2h6a1 1 0 1 0 0-2zm0 4a1 1 0 1 0 0 2h6a1 1 0 1 0 0-2zm0 4a1 1 0 1 0 0 2h4a1 1 0 1 0 0-2z'
        clipRule='evenodd'
      ></path>
    </svg>
  )
}
